import 'es-module-shims';
import { tm1ApiClient } from './tm1-api-client';

export const installImportMap = async () => {
  const importMap = await tm1ApiClient.fetchImportMap();
  global.importShim.addImportMap(importMap);
};
